export default function presentation(state = {
  allPresentations: [],
  presentation: {}
}, action) {
  switch (action.type) {
    case "PRESENTATION_CREATED":
      return state
    case "PRESENTATIONS_FETCHED":
      return Object.assign({}, state, {
        allPresentations: action.payload.presentations,
        presentation: {}
      })
    case "PRESENTATION_PRIVACY_UPDATED":
      return Object.assign({}, state, {
        allPresentations: state.allPresentations.map((p) => {
          return p._id === action.payload.presentation._id ? action.payload.presentation : p
        }),
        presentation: {}
      })
    case "EVENT_FETCHED":
      return Object.assign({}, state, {
        allPresentations: action.payload.presentations
      })
    case "PRESENTATION_FETCHED":
      return Object.assign({}, state, {
        presentation: action.payload.presentation
      })
    case "PRESENTATION_FILE_ADDED":
    case "PRESENTATION_PRIVACY_CHANGED":
    case "PRESENTATION_FILE_DELETED":
      return Object.assign({}, state, {
        allPresentations: state.allPresentations.map((p) => {
          return p._id === action.payload.presentation._id ? action.payload.presentation : p
        }),
        presentation: state.presentation ? action.payload.presentation : {}
      })
    default:
      return state
  }
}
